module.exports = __webpack_public_path__ + "img/parkinglist1.76b709fc.png";